module.exports = __webpack_public_path__ + "img/foto-perfil.922186ab.png";